import React from 'react'
import { updateDoc, doc } from "firebase/firestore";
import { auth ,db} from "../../firebase";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
export default function Studentnav() {
  const navigate = useNavigate();
  const MobileToggle = () => {
    var mobileTogggle = document.getElementById("mobileTogl");
    var navbar = document.getElementById("navbar");
    navbar.classList.toggle("navbar-mobile");
    mobileTogggle.classList.toggle("bi-list");
    mobileTogggle.classList.toggle("bi-x");
  };

  const HideNavbar = () => {
    var navbar = document.getElementById("navbar");
    if (navbar.classList.contains("navbar-mobile")) {
      navbar.classList.remove("navbar-mobile");
      var mobileTogggle = document.getElementById("mobileTogl");
      mobileTogggle.classList.toggle("bi-list");
      mobileTogggle.classList.toggle("bi-x");
    }
  };
  const handleSignout = async () => {
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      isOnline: false,
    });
    await signOut(auth);
    navigate("/");
  };

  return (
    <>
     <header id="header" className="d-flex align-items-center">
        <div className="container d-flex align-items-center justify-content-between">
          <h1 className="logo">

          <p>PICT Campus Placement System<span></span></p>
          </h1>
          <nav id="navbar" className="navbar">
            <ul>
            <li>
                <a
                  className="nav-link scrollto"
                  onClick={HideNavbar}
                  href="/stuhome"
                >
                  <i className="bi bi-house"></i>Student Home
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  onClick={HideNavbar}
                  href="/stuprofile"
                >
                  <i className="bi bi-house"></i>Profile
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  onClick={HideNavbar}
                  href="/dashboard" >
                  <i className="bi bi-info-circle"></i>Dashboard
                </a>
              </li>
              {/* <li><a className="nav-link scrollto" onClick={HideNavbar} href="#services"><i className="bi bi-eye"></i>Views</a></li> */}
              <li onClick={handleSignout}>
                <a
                  className="nav-link scrollto"
                  onClick={HideNavbar}
                  href="#Logout"
                >
                  <i className="bi bi-question-circle"></i>Log out
                </a>
              </li>
            </ul>
            <i
              className="bi bi-list mobile-nav-toggle"
              id="mobileTogl"
              onClick={MobileToggle}
            ></i>
          </nav>
        </div>
      </header>
  </>
  )
}
